export default "__VITE_ASSET__DlW7LhQC__"